import { useSetting } from "metabase/common/hooks";
import { useCallback } from "react";

const getOriginInfo = (origin: string) => {
  let url: URL;
  try {
    url = new URL(origin);
  } catch {
    return null;
  }

  let subdomain = url.hostname.split(".")[0];
  if (subdomain === "%2A" || subdomain === "*") {
    subdomain = "*";
  }
  let domain = url.hostname.split(".").slice(1).join(".");
  if (domain === "") {
    domain = subdomain;
    subdomain = "";
  }
  return {
    protocol: url.protocol,
    subdomain: subdomain,
    domain: domain,
    port: url.port,
  };
};

export const useIsValidSidekickClientEmbedOrigin = () => {
  const originsString = useSetting("sidekick-client-origins");

  return useCallback(
    (originString: string) => {
      if (!originsString) {
        return false;
      }

      const origin = getOriginInfo(originString);
      if (!origin) {
        return false;
      }

      const validOrigins = originsString
        .split(/[\s,]+/)
        .filter(Boolean)
        .map((origin) => getOriginInfo(origin))
        .filter(
          (origin): origin is NonNullable<ReturnType<typeof getOriginInfo>> =>
            origin != null,
        );

      return validOrigins.some((validOrigin) => {
        return (
          validOrigin.protocol === origin.protocol &&
          validOrigin.domain === origin.domain &&
          (validOrigin.subdomain === "*" ||
            validOrigin.subdomain === origin.subdomain) &&
          validOrigin.port === origin.port
        );
      });
    },
    [originsString],
  );
};
